VjsAdmin.CleverSyncQueue = (function () {
    const me = {};

    me.$table = $('#cleversync-queue-table');
    me.platform_id = me.$table.attr('data-platform-id');
    me.district_joint_guid = me.$table.attr('data-district-joint-guid');
    me.$queue_sync_modal = null;

    // quit polling the server if too many errors happen
    me.polling_error = 0;
    me.polling_error_threshold = 2;
    me.polling_timeout = null;

    // amount of time between refreshing the table
    me.polling_interval = 4000;

    me.init = function () {
        me.initTable();

        SafeDOM.registerQueueResultsPopup(me);

        SafeDOM.registerQueueSync(me, 'platforms.districts.cleversync.queue.add');
    };

    me.initTable = function () {
        me.$table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#cleversync-queue-table',
            formatNoMatches() {
                return 'No CleverSync History (...yet)';
            },
            idField: 'queue_id',
            sortName: 'date_queued',
            sortOrder: 'DESC',
            search: false,
            url: Slim.Router.pathFor('platforms.districts.cleversync.queue.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
            }),
            ...SafeDOM.makeQueueTableCallbacks(me),
            columns: [
                [
                    {
                        title: 'Status',
                        field: 'status',
                        align: 'center',
                        class: 'status',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'ID',
                        field: 'queue_id',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Queued',
                        field: 'date_queued',
                        align: 'left',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Started',
                        field: 'date_started',
                        align: 'left',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Action',
                        field: 'date_last_action',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Finished',
                        field: 'date_finished',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Mode',
                        field: 'mode',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Users',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 6,
                    },
                    {
                        title: 'Classes',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 6,
                    },
                    {
                        title: 'Errors',
                        field: 'number_of_errors',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Action',
                        field: 'actions',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                ],
                [
                    ...SafeDOM.getQueueUsersSubColumns(),
                    ...SafeDOM.getQueueClassesSubColumns(),
                ],
            ],
            responseHandler: SafeDOM.makeDistrictQueueResponseHandler({
                rowIdField: 'queue_id',
                hasClassesRow: true,
                cancelPermission: 'platforms.districts.cleversync.queue.cancel',
                cancelRoute: 'platforms.districts.cleversync.queue.cancel',
                logPermission: 'platforms.districts.cleversync.queue.log',
                logRoute: 'platforms.districts.cleversync.queue.log',
            }),
        });
    };

    return {
        init: me.init,
    };
}());
